import type { Release } from '../releases.ts';

export default {
  version: '0.99.1',
  date: '2026-10-10',
  title: 'Approval threads, activity log paging and worker figures',
  summary: [
    'Approval and task notes read as a conversation, with decisions as messages',
    'The Activity tab shows the newest 50 events, with Show older and filters',
    'Repeated events by the same person are grouped into one row',
    'Fixed: a reviewer’s decision comment is no longer cut off',
    'Fixed: System status shows worker memory and CPU as the container sees them',
  ],
  features: [
    'Approval and task notes read as a conversation: initials, the author and time above each note, your own notes on the right, and a “via link” tag for reviewers on a share link',
    'The request is the first message of an approval’s thread, in Tasks → Approvals and on the asset’s Sharing tab alike',
    'A decision is a message with an Approved or Changes requested badge and its comment inside; a decision without a comment and a task’s status changes are short centred lines',
    'A long thread scrolls inside its card and opens at the newest note',
    'The asset’s Activity tab shows the newest 50 events, with Show older for the rest of the trail, which is kept for good',
    'Filter the Activity tab by All, Edits, Processing, Sharing & approvals or Storage',
    'A run of the same event by the same person is one row, such as “Edited metadata ×6” with its time span; click it to see each one',
    'Deployment docs: a Caddy example for a separate media origin, next to the nginx one',
  ],
  fixes: [
    'A reviewer’s decision comment was cut off and hidden in Tasks → Approvals, on the Sharing tab and in task notes',
    'System status showed a worker’s memory with the file cache the kernel frees when needed, so a transfer worker looked full after a restore. It now shows the memory in use as docker stats does, with the cache in the tooltip',
    'The CPU bar on System status is full at the container’s own CPU limit, not the host’s cores, and says “of 2 cores”',
    'An OCI Archive restore is described as taking up to several hours, not up to an hour',
  ],
} satisfies Release;
